
import React from 'react';
import { Link } from 'react-router-dom';
import { Check, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';

const PaymentSuccess = () => {
  return (
    <div className="min-h-screen bg-wax-50 pt-24 pb-16 px-4">
      <div className="container mx-auto max-w-3xl">
        <Card className="bg-white shadow-lg rounded-2xl overflow-hidden">
          <CardContent className="p-0">
            <div className="bg-honey-500 p-6 flex justify-center">
              <div className="w-20 h-20 rounded-full bg-white flex items-center justify-center">
                <Check size={40} className="text-honey-500" />
              </div>
            </div>
            <div className="p-8 text-center">
              <h1 className="font-cormorant-garamond text-3xl font-bold mb-4">Платеж успешно выполнен!</h1>
              <p className="text-gray-600 mb-6">
                Спасибо за ваш заказ. Ваш платеж был успешно обработан,
                и мы уже начали готовить вашу посылку.
              </p>

              <div className="bg-honey-50 border border-honey-100 p-6 rounded-lg mb-6">
                <h3 className="font-medium text-lg mb-2">Что будет дальше?</h3>
                <ul className="text-left text-gray-700 space-y-2">
                  <li className="flex items-start">
                    <span className="mr-2">1.</span>
                    <span>Вы получите письмо с подтверждением заказа на указанную вами электронную почту.</span>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-2">2.</span>
                    <span>Ваш заказ будет подготовлен и отправлен в течение 1-3 рабочих дней.</span>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-2">3.</span>
                    <span>Мы отправим вам трек-номер для отслеживания посылки, как только она будет отправлена.</span>
                  </li>
                </ul>
              </div>

              <div className="flex flex-col sm:flex-row justify-center gap-4 mt-8">
                <Link to="/">
                  <Button variant="default" className="bg-honey-500 hover:bg-honey-600 text-black w-full sm:w-auto flex items-center">
                    Вернуться на главную
                    <ArrowRight size={16} className="ml-2" />
                  </Button>
                </Link>
                <Link to="/#products">
                  <Button variant="outline" className="border-honey-300 hover:bg-honey-50 text-honey-800 w-full sm:w-auto">
                    Просмотреть другие товары
                  </Button>
                </Link>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default PaymentSuccess;
